import { render, staticRenderFns } from "./vVideo.vue?vue&type=template&id=0653ff66&scoped=true"
import script from "./vVideo.vue?vue&type=script&lang=js"
export * from "./vVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0653ff66",
  null
  
)

export default component.exports